import { ai_api } from "../../utils/variables"

// Constants for KeywordTracking component
export const BUTTON_STYLES = {
  addButton: {
    width: "84px",
    padding: "8px 16px",
    borderRadius: "6px",
    color: "#FFFFFF",
    border: "none",
    fontWeight: "500",
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "background 0.2s ease-in-out",
  }
}

export const COLORS = {
  primary: "#F6255A",
  primaryHover: "#e11d4c",
  white: "#FFFFFF",
  error: "red",
  textMuted: "#888"
}

// export const TABLE_COLUMNS = [
//   { key: 'keyword', label: 'Keyword' },
//   { key: 'currentPosition', label: 'Current Position' },
//   { key: 'lastPosition', label: 'Last Position' },
//   { key: 'change', label: 'Change' },
//   { key: 'popularity', label: 'Popularity' },
//   { key: 'competitiveness', label: 'Competitiveness' },
//   { key: 'liveRanking', label: 'Live Ranking' }
// ]

export const TABLE_COLUMNS = [
  { key: "keyword", label: "Genres", tooltip: "Track genres for your games and apps to analyze their performance." },
  { key: "currentPosition", label: "Current Position", tooltip: "Current global position of your genre on the Meta Store for the selected country and apps.", sortable: true },
  { key: "lastPosition", label: "Last Position", tooltip: "Previous recorded global position for this genre.", sortable: true },
  { key: "change", label: "Change", tooltip: "Ranking difference between the last position and current position." },
  // { key: "popularity", label: "Popularity", tooltip: "Popularity score of this genre across KeyQuest — requires API." },
  // { key: "competitiveness", label: "Competitiveness", tooltip: "Determined by how frequently or slowly the genre's rank changes — requires API." },
  { key: "liveRanking", label: "Live Ranking", tooltip: "View where other apps and games currently rank for this genre on the Meta Store." },
  { key: "total", label: "Total", tooltip: "Total number of apps and games currently ranking for this genre on the Meta Store.", sortable: true }
];

export const DEFAULT_DATE_FORMAT = "yyyy-MM-dd"

export const API_ENDPOINTS = {
  countries: "/countries/",
  predefinedKeywords: "/tracker/predefined/keyword",
  trackedKeywords: "/tracker/tracking/get_user_tracked_category",
  removeEntity: "/tracker/tracking/remove_entity",
  appDetails: "/tracker/app/",
  keywordTracking: "/tracker/tracking/get_category_tracking",
  addCategoryTracking: "/tracker/tracking/add_category_tracking",
  genreSearch: "/tracker/genres/search",
  genreRecommendation: `${ai_api}/chat/genre-recommendation/`
}